import React from 'react';

import StatementAnalyzer from '../components/StatementAnalyzer';
import { useTypedSelector } from '../store';

import type { UploadConfig } from '../types';

interface StatementAnalyzerProps {
	mfe?: boolean;
	onDocumentProcessed?: (documentId: string) => void;
	initialCredits?: { creditsRemaining: number; canUpload: boolean };
	uploadConfig?: UploadConfig;
	basename?: string;
	apiUrl?: string;
	onFirstTimeUserUpload?: (documentId: string) => void;
	onGoBackToList?: () => void;
	onUpgradePlan?: () => void;
}

const StatementAnalyzerPage: React.FC<StatementAnalyzerProps> = ({
	mfe = false,
	onDocumentProcessed,
	initialCredits,
	uploadConfig,
	basename,
	apiUrl,
	onFirstTimeUserUpload,
	onGoBackToList,
	onUpgradePlan,
	...props
}) => {
	const authState = useTypedSelector((state) => state.mfeAuth);

	const isAuthenticated = authState.isAuthenticated;

	const shouldShowApp = isAuthenticated || !mfe;

	if (!shouldShowApp) {
		return (
			<div className="p-6 text-center">
				<div className="max-w-md mx-auto bg-yellow-50 dark:bg-yellow-900 border border-yellow-200 dark:border-yellow-700 rounded-lg p-6">
					<h2 className="text-lg font-semibold text-yellow-800 dark:text-yellow-200 mb-2">
						Authentication Required
					</h2>
					<p className="text-yellow-600 dark:text-yellow-300">
						Please provide an access token to use the Payment Statement
						analyzer.
					</p>
					{mfe && (
						<p className="p-2 text-sm text-yellow-500 dark:text-yellow-400 mt-2">
							Host application should pass accessToken prop.
						</p>
					)}
				</div>
			</div>
		);
	}

	return (
		<div>
			<StatementAnalyzer
				onDocumentProcessed={onDocumentProcessed}
				uploadConfig={uploadConfig}
				onFirstTimeUserUpload={onFirstTimeUserUpload}
				onGoBackToList={onGoBackToList}
				onUpgradePlan={onUpgradePlan}
				{...props}
			/>
		</div>
	);
};

export default StatementAnalyzerPage;
